import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { ChartLineUpIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { ApThroughputRangeSchema } from '@erp/rpc';
// fallow-ignore-next-line circular-dependency
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { requireAnyPermission, requireModules } from '../../route';

const APThroughputPage = lazyRouteComponent(() =>
  import('./APThroughputPage').then((module) => ({
    default: module.APThroughputPage,
  })),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/metrics',
  staticData: {
    app: {
      nav: {
        label: msg('Metrics', {
          context: 'sidebar nav label, Accounts Payable section',
        }),
        icon: <ChartLineUpIcon className="h-4 w-4" weight="fill" />,
        group: 'Accounts Payable',
        order: 6,
        groupOrder: 40,
      },
      access: {
        modulesAnyOf: [ProductModule.AP_INVOICING],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.APThroughputDashboard },
        ],
      },
    },
  },
  component: APThroughputPage,
  loader: () => ({
    crumb: msg('Metrics', { context: 'page breadcrumb' }),
  }),
  validateSearch: z.object({
    range: ApThroughputRangeSchema.optional().catch(undefined),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
    await requireAnyPermission({
      context,
      permissions: [
        { action: Action.Read, subject: Subject.APThroughputDashboard },
      ],
    });
  },
});
